import { consumeMagicLinkUseCase } from '@identity/application/use-cases';
import type { ILinkTokenStoragePort } from '@identity/application/ports';
import type { MagicLinkConsumer } from '@identity/composition/types';
import type { AuthHttpClientType } from '@identity/infrastructure/api';
import { createAuthApiRepository } from '@identity/infrastructure/repositories';

/**
 * Creates the link consume, built once and outside every slice.
 *
 * It is the one use case of the domain that writes the link session, so it takes the full storage
 * instead of the read-only credential source. It belongs to no flow because it runs before any flow
 * is known, and a copy per slice would be one reachable consume and two that nothing can call.
 */
export const createMagicLinkConsumer = (
  httpClient: AuthHttpClientType,
  linkTokenStorage: ILinkTokenStoragePort,
): MagicLinkConsumer => ({
  consumeMagicLink: consumeMagicLinkUseCase(
    createAuthApiRepository({ httpClient, authorizer: 'link' }),
    linkTokenStorage,
  ),
});
